import { ArrayUtils } from '../utils/arrayUtils';
import { GenericFilter } from './genericClass';
import { InternalEquipment } from './internalEquipment';
import { NumberUtils } from '../utils/numberUtils';
import { CalibrationAmbientConditions, CalibrationAmbientResultParticles } from './calibrationAmbientConditions';

export interface ICalibration {
    id: number;

    certificateNum: string;
    calibrationDate: Date;
    expirationDate: Date;

    idEquipment: number;

    internal: boolean;
    multichannel: boolean;
    channelNumber: number;
}

export class ParticleTest {
    id: number;
    idTestType: number;
    calibrationId: number;
    translation: string;
    type:number;
    results: ParticleTestResult[];
}

export class ParticleTestResult {
    id: number;
    testId: number;
    lot: number;
    validity: Date;
    channelPha: string;
    adjustement: number;
    nominal: number;
    measured: number;
    limit: string;
    median: number;
    result: string;
    pass: boolean;
    fail: boolean;
    efficiencyTest: string;
    obtainedEfficiency: string;
    size: string;
    noise: number;
    signal: number;
    accoundant: string;
    obsAccount: number;
    first_channel: string;
    previousValue: number;
    ajustedValue: number;
    certSize: string;
    obtResolution: string;
    countTime: number;
    standarTime: number
    uncertainty: string;
}

export class ParticleTestType {
    id: number;
    translation: string;
    order: number;
    type: number;
    limite: number;
}

export class ParticleCalibrationAudit {
    id: number;
    username: string;

    idAction: number;
    actionName: string;

    idStatus: number;
    nameStatus: string;
    statusTranslation: string;

    date: Date;

    currentVersion: number;
    signedVersion: number;

    changes: string;

    canDownload: boolean;
}

export class CalibrationAuditFilter extends GenericFilter {
}

export class ParticleCalibrationFilter extends GenericFilter {
    idStatus: number;
    idClient: number;
    regUser: string;

    name: string;
    type: string;

    maker: string;
    model: string;

    serialNum: string;
    certificateNum: string;

    calibrateDateStart: Date;
    calibrateDateEnd: Date;

    expirationDateStart: Date;
    expirationDateEnd: Date;

    realizationFcStart: Date;
    realizationFcEnd: Date;

    projectNo: string;

    idsVariable: number[];
    idsApp: number[];
    idPlace: number;

    cols: string[];
}



export enum CalibrationStatus {
    PENDIENTE_FIRMA = 1,
    FIRMADO = 2,
    EN_EJECUCION = 3,
    NO_VALIDO = 4
}

export enum CalibrationResponsibleEnum {
    INTERNAL = 1,
    EXTERNAL = 2
}

export enum CalibrationActionEnum {
    CREATE = 1,
    SAVE = 2,
    SIGN = 3
}
